export default {
    namespaced: true,

    state: {
        Response: {
            BoletoNumber: null,
            BoletoViewUrl: null
        }
    },

    mutations: {
        /**
         * Mapeia o response de sucesso do autorizador
         */
        boletoSuccessResponse(state, response) {
            state.Response.BoletoViewUrl = response.Data.BoletoViewerUrl;
            state.Response.BoletoNumber = response.Data.BoletoNumber;
        }
    }
};
